;(function () {
  angular
    .module('contrast.applications.modals')
    .controller('ModalTagApplicationCtrl', ModalTagApplicationCtrl)

  function ModalTagApplicationCtrl(
    $scope,
    $uibModalInstance,
    logger,
    TagFactory,
    TagService,
    ErrorService,
    applications,
    title
  ) {
    'ngInject'

    var appsId = _.map(applications, 'app_id')
    var originalTags = []

    angular.extend($scope, {
      applications: applications,
      title: title,
      has_tags: false,
      bulk_operation: false,
      taggingLabel: TagService.getTaggingLabel(),
      model: {
        tags: []
      }
    })

    angular.extend($scope, {
      ok: save,
      cancel: cancel,
      hasAvailableTags: hasAvailableTags,
      onTaggingSelect: TagService.onTaggingSelect.bind($scope, 'model.tags')
    })

    function init() {
      TagFactory.getApplicationsTags().then(function (response) {
        $scope.availableTags = response.data.tags
      }, _processError)

      TagFactory.getApplicationsTagsBulk(appsId).then(function (response) {
        if (response.data.tags) {
          originalTags = response.data.tags
          $scope.model.tags = response.data.tags
          $scope.has_tags = originalTags.length > 0
          $scope.bulk_operation = $scope.has_tags && appsId.length > 1
        }
      }, _processError)
    }

    function save() {
      TagFactory.tagApplicationsBulk(tagRequest()).then(function (response) {
        var data = response.data
        logger.logSuccess(data.messages[0])
        $uibModalInstance.close()
      }, _processError)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function _processError(response) {
      ErrorService.processError(response)
      $uibModalInstance.close()
    }

    function tagRequest() {
      var tagsRemove = _.difference(originalTags, $scope.model.tags)
      return {
        applications_id: appsId,
        tags: $scope.model.tags,
        tags_remove: tagsRemove
      }
    }

    function hasAvailableTags() {
      return (
        !$scope.has_tags &&
        $scope.model.tags &&
        $scope.model.tags.length == 0 &&
        $scope.availableTags &&
        $scope.availableTags.length == 0
      )
    }

    init()
  }
})()
